import React from 'react';
import Button from 's2s-button';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import { getIntlText } from '../../js/utilities';

const DeleteContactModalContainer = styled.div`
  background-color: ${colorGrid.gray0};
  box-shadow : 0 6px 16px 0 rgba(3, 3, 4, 0.26);
  border-radius: 4px;
  padding: 25px;
  width: 281px;
`;

const HeaderText = styled.div`
  color: ${colorGrid.gray9};
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
`;

const DescriptionText = styled.div`
  color: ${colorGrid.gray5};
  /* font-size: 12px; */
  line-height: 1.67;
  padding-bottom: 15px;
  padding-top: 15px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const DeleteContactModal = (props) => {

  return (
    <DeleteContactModalContainer className="DeleteContactModal" >
      <HeaderText className="HeaderText" >
        {getIntlText(props.intl,'CONTACT-DETAILS-CARD-MODAL-HEADER-DELETE-CONTACT', "Are you sure you want to delete this contact?")}
      </HeaderText>
      <DescriptionText className="descriptionText" >
        {getIntlText(props.intl, 'CONTACT-DETAILS-CARD-MODAL-DESCRIPTION-DELETE-CONTACT', "Completing this action will permanently remove the current contact’s information. ")}
      </DescriptionText>
      <ButtonContainer className="buttonContainer" >
        <Button
          cbClick={props.cbCancelClick}
          buttonType="secondary"
          buttonSize="medium"
          buttonLabel={getIntlText(props.intl, 'CONTACT-DETAILS-CARD-MODAL-CANCEL-BUTTON', "Cancel")}
        />
        <Button
          cbClick={props.cbConfirmDelete}
          buttonType="primaryRed"
          buttonSize="medium"
          buttonLabel={getIntlText(props.intl, 'CONTACT-DETAILS-CARD-MODAL-DELETE-BUTTON', "Delete")}
        />
      </ButtonContainer>
    </DeleteContactModalContainer>
  );
};

DeleteContactModal.propTypes = {
  cbCancelClick: PropTypes.func,
  cbConfirmDelete: PropTypes.func,
  intl : PropTypes.string
};

DeleteContactModal.defaultProps = {
  cbCancelClick: () => { console.log('cbCancelClick is not defined. '); },
  cbConfirmDelete: () => { console.log('cbConfirmDelete is not defined.'); },
};

export default DeleteContactModal;
